import { isEnglish } from '../../lib/i18n'

export const scormStrings = isEnglish ? {
  title: 'SCORM results', latest: 'Latest reported result for each course', score: 'Score',
  questions: 'Question results', question: 'Question ID', response: 'Selected response (code)',
  correctResponse: 'Correct response (code)', result: 'Result',
  passed: 'Passed', failed: 'Failed', completed: 'Completed', correct: 'Correct', wrong: 'Wrong',
  neutral: 'Neutral', unanticipated: 'Unanticipated', unreported: 'Not reported',
  noQuestions: 'This package did not report question details.',
  codes: 'The package reports question and answer codes, not their full wording.',
  error: 'Could not load SCORM results.',
} : {
  title: 'نتائج SCORM', latest: 'آخر نتيجة مسجلة لكل دورة', score: 'الدرجة',
  questions: 'نتائج الأسئلة', question: 'معرف السؤال', response: 'الإجابة المختارة (الرمز)',
  correctResponse: 'الإجابة الصحيحة (الرمز)', result: 'النتيجة',
  passed: 'ناجح', failed: 'راسب', completed: 'مكتمل', correct: 'صحيح', wrong: 'خطأ',
  neutral: 'محايد', unanticipated: 'غير متوقع', unreported: 'لم يتم الإبلاغ',
  noQuestions: 'لم ترسل الحزمة تفاصيل الأسئلة.',
  codes: 'ترسل الحزمة رموز الأسئلة والإجابات دون نصوصها الكاملة.',
  error: 'تعذر تحميل نتائج SCORM.',
}
